// extracted by mini-css-extract-plugin
module.exports = {"address__ie-autocomplete":"address__ie-autocomplete__EuKFf","address__switch-mode-button":"address__switch-mode-button__26uxu","address__IE":"address__IE__sy_XZ"};